import type { TConversation } from '@cascade/api-client/conversations';
import { getEndOfDay } from '@cascade/core/utils';
import type {
  TConversationSort,
  TConversationsQuery,
} from '@cascade/react/conversations';
import {
  addSort,
  filterValueToDate,
  removeSort,
  setSortDirection,
} from '@cascade/ui-library';
import type {
  TActiveSort,
  TColumnSortDirection,
  TDataViewConfig,
} from '@cascade/ui-library';
import type { TConversationRow } from './DataControls.types.ts';

export const TITLE_FIELD_ID = 'title';
export const DATE_FIELD_ID = 'date';

export const buildConversationRow = (
  conversation: TConversation,
): TConversationRow => ({
  id: conversation.conversation_id,
  title: conversation.title,
  date: conversation.date,
});

const buildConversationSort = ({
  fieldId,
  direction,
}: TActiveSort): TConversationSort => ({
  field: fieldId === DATE_FIELD_ID ? 'date' : 'title',
  direction,
});

export const buildConversationsQuery = ({
  query,
  filters,
  sorts,
}: TDataViewConfig): TConversationsQuery => {
  const dateFilter = filters.find(({ filterId }) => filterId === DATE_FIELD_ID);
  const [startedFrom, startedUntil] = dateFilter?.values ?? [];
  const startedUntilDay = startedUntil
    ? filterValueToDate(startedUntil)
    : undefined;

  return {
    search: query,
    startedFrom: startedFrom ? filterValueToDate(startedFrom) : undefined,
    startedUntil: startedUntilDay ? getEndOfDay(startedUntilDay) : undefined,
    sorts: sorts.map(buildConversationSort),
  };
};

// @todo goes once the UI Library gives DataView and Table one sorting vocabulary
export const getColumnDirectionFromSorts = (
  sorts: TActiveSort[],
  fieldId: string,
): TColumnSortDirection => {
  const sort = sorts.find((candidate) => candidate.fieldId === fieldId);

  if (!sort) {
    return 'none';
  }

  return sort.direction === 'asc' ? 'ascending' : 'descending';
};

// @todo goes once the UI Library gives DataView and Table one sorting vocabulary
export const cycleSortsFromColumn = (
  sorts: TActiveSort[],
  fieldId: string,
): TActiveSort[] => {
  const direction = getColumnDirectionFromSorts(sorts, fieldId);

  if (direction === 'none') {
    return addSort(sorts, fieldId, 'asc');
  }

  if (direction === 'ascending') {
    return setSortDirection(sorts, fieldId, 'desc');
  }

  return removeSort(sorts, fieldId);
};
